import { backendUrl } from './App';

export const ADMIN_AUTH_FAILURE_EVENT = 'ifood:admin-auth-failure';

/** Sends administrative requests with the signed-in session and reports lost access centrally. */
export async function adminFetch(
  path: string,
  init: RequestInit = {},
  options: { reportForbidden?: boolean } = {},
): Promise<Response> {
  const response = await fetch(`${backendUrl}${path}`, {
    ...init,
    credentials: 'include',
    cache: !init.method || init.method.toUpperCase() === 'GET' ? 'no-store' : init.cache,
    headers: { 'ngrok-skip-browser-warning': 'true', ...init.headers },
  });
  if (response.status === 401 || (response.status === 403 && options.reportForbidden !== false)) {
    window.dispatchEvent(new CustomEvent(ADMIN_AUTH_FAILURE_EVENT, { detail: response.status }));
  }
  return response;
}
